import { styled, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export const CardWrapper = styled("div")((props) => ({
  overflowY: "hidden",
  display: "flex",
  flexDirection: "column",
  height: "100%",
}));

export const ScrollBox = styled("div")((props) => ({
  flex: 1,
  overflowY: "scroll",
  paddingBottom: props.theme.spacing(8),
  height: "100%",
}));

export function NoResultsFallback() {
  const { t } = useTranslation();
  return (
    <Typography component="span" variant="h4">
      {t("global.no_results_found_text")}
    </Typography>
  );
}
